import track, { ecommerce, priceDescr, product, productGroup } from 'c9-tracking';
import { PackageInfo, ProductNames, SelectedAdditionalCoverage, TeCommerce } from '../interfaces/interfaces';

const ONSAproduct = ({ config, selection, pContext }: TeCommerce, onePrice: boolean) => {
    const { packages, selectedAdditionalCoverages, selectedPackage, selectedDeductible } = pContext;
    const criteria: Record<ProductNames, Array<any>> = {
        CAR: [
            { name: 'mileage', value: selection?.mileage ? selection.mileage : 15000 },
            { name: 'deductible', value: selectedDeductible },
            { name: 'isLiabilityOnlyCoverageGroup', value: selection.packageInfo === PackageInfo.LIABILITY_ONLY }
        ],
        CHILD: []
    };

    // define product
    const prod: product = {
        name: selectedPackage.productTitle,
        id: selectedPackage.productTitle,
        group: productGroup.insurance,
        price: onePrice
            ? selectedPackage.monthlyPrice
            : [packages[0].monthlyPrice, packages[1].monthlyPrice, packages[2].monthlyPrice],
        //priceDescr: +selection.premiumRate === 12 ? priceDescr.monthly : priceDescr.yearly,
        priceDescr: priceDescr.monthly,
        excess: selectedDeductible,
        coverages: selectedAdditionalCoverages.map((selectedAdditionalCoverage: SelectedAdditionalCoverage) => ({
            name: selectedAdditionalCoverage.coverageAlias,
            value: selectedAdditionalCoverage.selected ? 1 : 0 // 1/0 = selected/not selected
        })),
        criteria: criteria[config.product] ? criteria[config.product] : []
    };

    return prod;
};

const viewProduct = async ({ config, selection, pContext }: TeCommerce) => {
    const prod = ONSAproduct({ config, selection, pContext }, false);
    await ecommerce.viewProduct(prod);
};

const addToCart = async ({ config, selection, pContext }: TeCommerce) => {
    const prod = ONSAproduct({ config, selection, pContext }, true);
    await ecommerce.cart.add(prod);
};

const checkout = async ({ config, selection, pContext }: TeCommerce) => {
    const prod = ONSAproduct({ config, selection, pContext }, true);
    await ecommerce.checkout(1, [prod]);
};

const purchase = async ({ config, selection, pContext }: TeCommerce) => {
    const prod = ONSAproduct({ config, selection, pContext }, true);
    track.info([
        { key: 'ec.purchase payload', value: prod },
        { key: 'ec.purchase quoteId', value: pContext.selectedPackage.quoteId }
    ]);
    await ecommerce.purchase([prod], pContext.selectedPackage.quoteId);
};

const eCommerce = {
    viewProduct,
    addToCart,
    checkout,
    purchase
};

export default eCommerce;
